import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { ConstructionVariationsService } from '../services/constructionVariations.service';
import type { ConstructionVariation } from '../types/construction-boq.types';
import { toast } from 'sonner';

export function useBoqVariations(boqId: string) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ['construction-boqs', 'variations', boqId],
    queryFn: () => ConstructionVariationsService.getVariations(boqId),
    enabled: !!boqId,
  });

  const createMutation = useMutation({
    mutationFn: (data: Partial<ConstructionVariation>) => 
      ConstructionVariationsService.createVariation({ ...data, boq_id: boqId }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['construction-boqs', 'variations', boqId] });
      toast.success('Tạo yêu cầu phát sinh (VO) thành công');
    },
    onError: (error: any) => {
      toast.error('Lỗi khi tạo VO: ' + error.message);
    }
  });

  return {
    variations: query.data || [],
    isLoading: query.isLoading,
    error: query.error,
    createVariation: createMutation.mutateAsync,
    isCreating: createMutation.isPending,
  };
}
